export default "__VITE_ASSET__1be5c3da__"